/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { keyframes } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'

// Players then Spares — row counts only keep the placeholder about as tall as
// a typical roster so the page doesn't jump when the data lands.
const SECTION_ROW_COUNTS = [8, 3]

/** Loading placeholder for the game roster: section titles + table rows. */
const GameRosterSkeleton: React.FC = () => (
  <div css={wrapStyle} aria-hidden='true' data-testid='game-roster-skeleton'>
    {SECTION_ROW_COUNTS.map((rowCount, sectionIndex) => (
      <div key={sectionIndex} css={sectionStyle}>
        <div css={[barStyle, titleStyle]} />
        <div css={[barStyle, headerStyle]} />
        {Array.from({ length: rowCount }, (_, rowIndex) => (
          <div key={rowIndex} css={rowStyle}>
            <div css={[barStyle, avatarStyle]} />
            <div css={[barStyle, nameStyle]} />
            <div css={[barStyle, cellStyle]} />
            <div css={[barStyle, cellStyle]} />
          </div>
        ))}
      </div>
    ))}
  </div>
)

export default GameRosterSkeleton

// ---- styled ----
const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 0.9; }
  100% { opacity: 0.5; }
`
const barStyle = css`
  border-radius: 8px;
  background-color: ${colors.SECONDARY_300};
  animation: ${pulse} 1.4s ease-in-out infinite;
`
const wrapStyle = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
const sectionStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
const titleStyle = css`
  width: 96px;
  height: 16px;
  margin-bottom: 8px;
`
const headerStyle = css`
  height: 40px;
`
const rowStyle = css`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 48px;
  padding: 0 16px;
`
const avatarStyle = css`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
`
const nameStyle = css`
  flex: 3;
  height: 16px;
`
const cellStyle = css`
  flex: 2;
  height: 16px;
`
